import React from 'react';
import BaseAdHocPage from "../../../framework/util/uicomps/BaseAdHocPage";
import PressPalletIcon from "../PressPalletIcon";
import PalletManifestChooser from "./PalletManifestChooser";
import {Typography} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";


const ReprintPalletShowPallets = ({currentState, sendEvent}) => {

    const onSelectPallet = (pallet) => {
        sendEvent("SELECTED", pallet);
    }

    const contentItems = [];
    const pallets = currentState?.context?.pallets ? currentState?.context?.pallets : [];
    pallets.sort((a, b) => (a.unloadTime > b.unloadTime) ? -1 : 1)

    const lastPallet = pallets ? pallets.shift() : null;
    const lastPallets = lastPallet  ? [lastPallet] : [];
    contentItems.push(
        (
            <PalletManifestChooser pallets={lastPallets} onSelectPallet={(pallet)=>onSelectPallet(pallet)} paging={false} search={false}
                                   title={"Last Manifest"}
            />
        )
    );


    contentItems.push(
        (
            <PalletManifestChooser pallets={pallets} onSelectPallet={(pallet)=>onSelectPallet(pallet)}
                                   title={"Manifests"}
            />
        )
    );

    const buttonItems = [];

    const title = 'Print Manifest';
    const description = 'Print or Reprint Previously Generated Manifests';


    const main = (
            <BaseAdHocPage icon={<PressPalletIcon/>} title={title} width={"100%"}
                           description={description} buttons={buttonItems}
                           content={contentItems}/>

    );


    const PageInGrid = (

        <Grid container
              direction="row"
              justify="center"
              alignItems="center"
        >
            <Grid item xs={2}>
            </Grid>
            <Grid item xs={8}>
                {main}
            </Grid>
            <Grid item xs={2}>
            </Grid>
        </Grid>

    );


    return PageInGrid;


}

export default ReprintPalletShowPallets;